import { BaseEntity } from '@app/_models/baseEntity';

export  class BaseDto extends BaseEntity {
        created: Date;
        lastUpdateTime: Date;
        deleted: number | null;
    }